import axios from 'axios'

const SSR_SEGMENT_URL = '/a'

export enum SegmentSSRMethodTypes {
  identify = 'identify',
  track = 'track'
}

export const segmentSSR = {
  identify: async (userId: string, traits?: Record<string, unknown>) => {
    axios({
      url: SSR_SEGMENT_URL,
      method: 'POST',
      data: {
        method: SegmentSSRMethodTypes.identify,
        userId,
        ...traits
      }
    })
  },
  track: (event: string, properties?: Record<string, unknown>, callback?: () => void) => {
    axios({
      url: SSR_SEGMENT_URL,
      method: 'POST',
      data: {
        method: SegmentSSRMethodTypes.track,
        event,
        ...properties
      }
    }).then(callback)
  }
}
